import { cn } from '#/utils/cn';

type BrandAccentProps = {
  variant?: 'short' | 'long';
};

export function BrandAccent({ variant = 'long' }: BrandAccentProps) {
  return (
    <div
      className={cn('bg-accent h-6', {
        'w-62': variant === 'long',
        'w-24': variant === 'short',
      })}
      aria-hidden="true"
    ></div>
  );
}
